import Vue from 'vue';
import BaseImage from './BaseImage';
import BaseSpinner from './BaseSpinner';
import BaseTooltip from './BaseTooltip';

const comps = {
  BaseFormGroup: () => import(/* webpackChunkName: 'BaseFormGroup' */ './BaseFormGroup'),
  BaseImage,
  BaseSpinner,
  BaseTooltip,
};

// Register global components only which is main.js needed
Object.entries(comps).forEach(([name, comp]) => Vue.component(name, comp));

// const context = require.context('.', false, /Base\w+\.vue$/);
// context.keys().forEach((fileName) => {
//   const componentConfig = context(fileName);
//   const componentName = fileName.replace(/\.\/|\.vue/g, '');
//   Vue.component(componentName, componentConfig.default || componentConfig);
// });
